/**
 * Message Utilities
 *
 * Utilities for getting localized messages and labels
 */

import { labels, messages } from '../../constants/Messages';
import { IMAGE_SOURCE_MAX_SIZE_MB, getImageMaxSizeMB } from './inputValidation';

/**
 * Get a label by key
 */
export const getLabel = (key: string): string => {
  return (labels as any)[key];
};

/**
 * Get a message by key
 */
export const getMessage = (key: string): string => {
  return (messages as any)[key];
};

export const getImageSizeMessage = (): string =>
  ((labels as any)['imageSize'] as string).replace('$1', String(getImageMaxSizeMB()));

export const getImageSourceSizeMessage = (): string =>
  ((labels as any)['imageSize'] as string).replace('$1', String(IMAGE_SOURCE_MAX_SIZE_MB));

export const getImageFormatMessage = (): string => (labels as any)['imageFormat'];

/**
 * Get formatted message for valid email confirmation
 */
export const getMessageValidEmail = ({
  mail,
  correspondentName,
}: {
  mail: string;
  correspondentName: string;
}): string => {
  return `Se creará un nuevo perfil para el usuario ${mail} en el corresponsal ${correspondentName}, ¿desea continuar?`;
};

/**
 * Get formatted message for removing user
 */
export const getMessageRemoveUser = (mail: string): string => {
  return `¿Quitar a ${mail} de la lista blanca?`;
};

/**
 * Get formatted message for toggling whitelist
 */
export const getMessageToogleWhiteList = (acction: string): string => {
  return `¿Estas seguro en ${acction} la lista blanca?`;
};

/**
 * Get formatted message with date
 */
export const getMessageDate = (date: string): string => {
  return `Fecha: ${date}`;
};
